export default "__VITE_ASSET__3$XpiKfD__"